import { AxiosConfig } from '../../componentes/axiosConfig';

/**
 * Preenche um html input do tipo select com o rastreador instalado no rastreável selecionado.
 */
(function () {
    const select2DesinstalarRastreador = $('#select2-desinstalar-rastreador');
    const select2PopularRastreaveis    = $('#select2-popular-rastreaveis');
    if (select2PopularRastreaveis.length === 0 || select2DesinstalarRastreador.length === 0) {
        return;
    }

    select2PopularRastreaveis.on('select2:select', function (evento) {
        const objetoResposta = evento.params.data;
        if (objetoResposta.id) {
            _carregarRastreadorRastreavel(objetoResposta.id);
        }
    });

    /**
     * Popula o campo select com o rastreador instalado no rastreável.
     *
     * @param {number} rastreavelId
     * @return {void}
     */
    function _carregarRastreadorRastreavel (rastreavelId) {
        const axiosRequest = (new AxiosConfig()).instanciaAxios();

        axiosRequest.get(_montarUrlConsulta(rastreavelId))
        .then((response) => {
            let arrayRastreador = [{id: '', text: 'Selecione um rastreador'}];
            if (Array.isArray(response.data) && response.data.length > 0) {
                response.data.forEach((rastreavel) => {
                    arrayRastreador.push({id: rastreavel.rastreador, text: rastreavel.imei});
                });
            }

            select2DesinstalarRastreador.html(null);
            select2DesinstalarRastreador.select2({
                data: arrayRastreador
            });
        })
        .catch((error) => {
            console.log(error);
        });
    }

     /**
      * Url para consultar o rastreador instalado no rastreável.
      *
      * @param {number} rastreavelId
      * @return {string}
     */
     function _montarUrlConsulta (rastreavelId) {
        const urlSistema  = `${window.location.protocol}//${window.location.host}/rastreaveis/json`;
        const camposBusca = 'campos[rastreavel]=id as rastreavel&campos[rastreador]=id as rastreador,imei';
        const filtroBusca = `rastreavelId[]=${rastreavelId}&qtdRegistros=1`;

        return `${urlSistema}?${camposBusca}&${filtroBusca}`;
    }
})();
